import Vue from "vue";
import Vidyo from "@/plugins/vidyo";
import store from "@/store/index";

Vue.use(Vidyo, { store });
